module.exports = __webpack_public_path__ + "media/images/promo/spiral-up-app-f51b06c933b72b60e22fdc5f672cc46d32fbb83920ccfbb4c30a4eb1ddac4069.jpg";